import React from 'react';

import { useConvertorCrossRatesData } from 'hooks';

import AllRatesTableContainer from 'containers/AllRatesTableContainer';
import AllBanksTableContainer from 'containers/AllBanksTableContainer';
import CrossRates from 'components/CrossRates';
import LinksBlock from 'components/LinksBlock';
import CurrenciesLinksContainer from 'containers/CurrenciesLinksContainer';
import RatesDynamic from 'components/RatesDynamic';
import Banner from 'components/Banner';
import ContentBannerSection from 'components/ContentBannerSection';
import PageContent from 'components/PageContent';
import CurrencyConverterContainer from 'containers/CurrencyConverterContainer';
import CurrencyExchangeTable from 'components/CurrencyExchangeTable';

const ConvertorPageContent = () => {
  useConvertorCrossRatesData();

  return (
    <PageContent>
      <CurrencyConverterContainer />
      <ContentBannerSection hideOnDesktop>
        <Banner id="rp-react-banner-content-2-a" slot="bn-slot-content-2-a" />
      </ContentBannerSection>
      <AllRatesTableContainer />
      <ContentBannerSection>
        <Banner id="rp-react-banner-content-2" slot="bn-slot-content-2" />
      </ContentBannerSection>
      <AllBanksTableContainer />
      <CurrencyExchangeTable />
      <RatesDynamic />
      <CrossRates />
      <CurrenciesLinksContainer />
      <LinksBlock />
    </PageContent>
  );
};

export default ConvertorPageContent;
